import React, { useState } from 'react';
import bgimage from '../../assets/images/bgimage.jpg'
import { Link } from 'react-router-dom';
import SignupHook from '../../hooks/SignupHook'

export default function Signup() {

    const provinces={
        "Pakistan": {
          "Khyber Pakhtunkhwa (KPK)": [
            "Abbottabad",
            "Bajaur",
            "Bannu",
            "Battagram",
            "Buner",
            "Charsadda",
            "Chitral",
            "Dera Ismail Khan",
            "Hangu",
            "Haripur",
            "Karak",
            "Kohat",
            "Kohistan",
            "Kurram",
            "Lakki Marwat",
            "Lower Dir",
            "Lower Kohistan",
            "Malakand",
            "Mansehra",
            "Mardan",
            "Mohmand",
            "North Waziristan",
            "Nowshera",
            "Orakzai",
            "Peshawar",
            "Shangla",
            "South Waziristan",
            "Swabi",
            "Swat",
            "Tank",
            "Torghar",
            "Upper Dir",
            "Upper Kohistan"
          ],
          "Punjab": [
            "Attock",
            "Bahawalnagar",
            "Bahawalpur",
            "Bhakkar",
            "Chakwal",
            "Chiniot",
            "Dera Ghazi Khan",
            "Faisalabad",
            "Gujranwala",
            "Gujrat",
            "Hafizabad",
            "Jhang",
            "Jehlum",
            "Kasur",
            "Khanewal",
            "Khushab",
            "Lahore",
            "Layyah",
            "Lodhran",
            "Mandi Bahauddin",
            "Mianwali",
            "Multan",
            "Muzaffargarh",
            "Nankana Sahib",
            "Narowal",
            "Okara",
            "Pakpattan",
            "Rahim Yar Khan",
            "Rajanpur",
            "Rawalpindi",
            "Sahiwal",
            "Sargodha",
            "Sheikhupura",
            "Sialkot",
            "Toba Tek Singh",
            "Vehari"
          ],
          "Sindh": [
            "Badin",
            "Dadu",
            "Ghotki",
            "Hyderabad",
            "Jacobabad",
            "Jamshoro",
            "Karachi",
            "Kashmore",
            "Khairpur",
            "Korangi",
            "Larkana",
            "Malir",
            "Matiari",
            "Mirpurkhas",
            "Naushahro Feroze",
            "Qambar Shahdadkot",
            "Sanghar",
            "Shaheed Benazirabad",
            "Shikarpur",
            "Sujawal",
            "Tharparkar",
            "Thatta",
            "Umerkot"
          ],
          "Balochistan": [
            "Awaran",
            "Barkhan",
            "Bolan",
            "Chagai",
            "Dera Bugti",
            "Gwadar",
            "Harnai",
            "Jafarabad",
            "Jhal Magsi",
            "Kalat",
            "Kech",
            "Kharan",
            "Khuzdar",
            "Killa Abdullah",
            "Killa Saifullah",
            "Kohlu",
            "Lasbela",
            "Loralai",
            "Mastung",
            "Musakhel",
            "Naseerabad",
            "Nushki",
            "Panjgur",
            "Pishin",
            "Quetta",
            "Sherani",
            "Sibi",
            "Sohbatpur",
            "Washuk",
            "Zhob",
            "Ziarat"
          ],
          "Islamabad Capital Territory": [
            "Islamabad"
          ],
          "Gilgit-Baltistan": [
            "Astore",
            "Baltistan Division",
            "Diamer",
            "Ghanche",
            "Gilgit",
            "Hunza",
            "Kharmang",
            "Nagar",
            "Shigar",
            "Skardu"
          ],
          "Azad Kashmir": [
            "Bagh",
            "Bhimber",
            "Hattian Bala",
            "Kotli",
            "Mirpur",
            "Muzaffarabad",
            "Neelum",
            "Poonch",
            "Sudhanoti"
          ]
        }
      }

 
    const [name, setname] = useState('')
    const [email, setemail] = useState('')
    const [phone, setphone] = useState('')
    const [province, setprovince] = useState('')
    const [district, setdistrict] = useState('')

    const provinceOptions = Object.keys(provinces.Pakistan);
    const districtOptions = province ? provinces.Pakistan[province] : [];

    
    // const[additional_phone,setadditional_phone]=useState('')
    // const[whatsapp_phone,setwhatsapp_phone]=useState('')

    const [address, setaddress] = useState('')
    // const[map_location,setmap_location]=useState('')
    const [reg_no, setreg_no] = useState('')
    const [password, setpassword] = useState('')

    // const[focal_person_name,setfocal_person_name]=useState('')
    // const[focal_person_phone,setfocal_person_phone]=useState('')
    // const[focal_person_email,setfocal_person_email]=useState('')
    const data = {
        name, email, phone, address, reg_no,province,district, password
    }
    const { agencySignup, isLoading } = SignupHook()
    const submitForm = async (e) => {
        e.preventDefault()
        await agencySignup(data)
    }


    return (
        <div className='container-fluid bg-white signup_form '>

            <div className="row px-0">
                <div className="col-md-6 col-lg-5 d-lg-block d-none p-0">
                    <div className="bg_image">
                        <img src={bgimage} className='p-0' alt="" />

                    </div>

                </div>
                <div className="col-md-12 col-lg-6 px-md-4 px-xl-4 px-4 my-auto mx-auto p-0">
                    <form onSubmit={submitForm}>
                        <div className="mb-0 mt-md-0 mt-3">
                            <h1>Register your Agency</h1>
                            <p>Create account and offer services!</p>
                        </div>
                        <div className="row">

                            <div className="col-md-6 py-0">
                                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.5 21C4.5 19.6044 4.5 18.9067 4.67224 18.3389C5.06004 17.0605 6.06046 16.06 7.33886 15.6722C7.90665 15.5 8.60444 15.5 10 15.5H15C16.3956 15.5 17.0933 15.5 17.6611 15.6722C18.9395 16.06 19.94 17.0605 20.3278 18.3389C20.5 18.9067 20.5 19.6044 20.5 21M8 7.5C8 9.98528 10.0147 12 12.5 12C14.9853 12 17 9.98528 17 7.5C17 5.01472 14.9853 3 12.5 3C10.0147 3 8 5.01472 8 7.5Z" stroke="#9197B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <input
                                    type="text" className='m-0'
                                    placeholder='Agency Name'
                                    required
                                    value={name}
                                    onChange={(e) => setname(e.target.value)}
                                />
                            </div>
                            <div className="col-md-6 py-0">
                                <svg viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.5 7.5C0.5 5.42893 2.17893 3.75 4.25 3.75H26.75C28.8211 3.75 30.5 5.42893 30.5 7.5V22.5C30.5 24.5711 28.8211 26.25 26.75 26.25H4.25C2.17893 26.25 0.5 24.5711 0.5 22.5V7.5ZM4.25 5.625C3.21447 5.625 2.375 6.46447 2.375 7.5V7.9067L15.5 15.7817L28.625 7.9067V7.5C28.625 6.46447 27.7855 5.625 26.75 5.625H4.25ZM28.625 10.0933L19.7974 15.3899L28.625 20.8223V10.0933ZM28.5617 22.9849L17.9859 16.4767L15.5 17.9683L13.0141 16.4767L2.43831 22.9849C2.65202 23.7854 3.38216 24.375 4.25 24.375H26.75C27.6178 24.375 28.348 23.7854 28.5617 22.9849ZM2.375 20.8223L11.2026 15.3899L2.375 10.0933V20.8223Z" fill="#9197B3" />
                                </svg>

                                <input
                                    type="email" className='m-0'
                                    placeholder='Email'
                                    required
                                    value={email}
                                    onChange={(e) => setemail(e.target.value)}
                                />
                            </div>
                            <div className="col-md-6 py-0">

                                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.5 17.5H12.51M8.7 22H16.3C17.4201 22 17.9802 22 18.408 21.782C18.7843 21.5903 19.0903 21.2843 19.282 20.908C19.5 20.4802 19.5 19.9201 19.5 18.8V5.2C19.5 4.07989 19.5 3.51984 19.282 3.09202C19.0903 2.71569 18.7843 2.40973 18.408 2.21799C17.9802 2 17.4201 2 16.3 2H8.7C7.5799 2 7.01984 2 6.59202 2.21799C6.21569 2.40973 5.90973 2.71569 5.71799 3.09202C5.5 3.51984 5.5 4.0799 5.5 5.2V18.8C5.5 19.9201 5.5 20.4802 5.71799 20.908C5.90973 21.2843 6.21569 21.5903 6.59202 21.782C7.01984 22 7.57989 22 8.7 22ZM13 17.5C13 17.7761 12.7761 18 12.5 18C12.2239 18 12 17.7761 12 17.5C12 17.2239 12.2239 17 12.5 17C12.7761 17 13 17.2239 13 17.5Z" stroke="#9197B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <input
                                    type="number" className='m-0'
                                    placeholder='Mobile Number'
                                    required
                                    value={phone}
                                    onChange={(e) => setphone(e.target.value)}
                                />
                            </div>

                            <div className="col-md-6 py-0">

                                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.5 17.5H12.51M8.7 22H16.3C17.4201 22 17.9802 22 18.408 21.782C18.7843 21.5903 19.0903 21.2843 19.282 20.908C19.5 20.4802 19.5 19.9201 19.5 18.8V5.2C19.5 4.07989 19.5 3.51984 19.282 3.09202C19.0903 2.71569 18.7843 2.40973 18.408 2.21799C17.9802 2 17.4201 2 16.3 2H8.7C7.5799 2 7.01984 2 6.59202 2.21799C6.21569 2.40973 5.90973 2.71569 5.71799 3.09202C5.5 3.51984 5.5 4.0799 5.5 5.2V18.8C5.5 19.9201 5.5 20.4802 5.71799 20.908C5.90973 21.2843 6.21569 21.5903 6.59202 21.782C7.01984 22 7.57989 22 8.7 22ZM13 17.5C13 17.7761 12.7761 18 12.5 18C12.2239 18 12 17.7761 12 17.5C12 17.2239 12.2239 17 12.5 17C12.7761 17 13 17.2239 13 17.5Z" stroke="#9197B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                              <select name="" id="" value={province} onChange={(e)=>{setprovince(e.target.value);setdistrict('')}} required>
                              <option value="">Select Province</option>
                                {provinceOptions.map((prov) => (
                                    <option key={prov} value={prov}>
                                    {prov}
                                    </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-md-6 py-0">

                                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.5 17.5H12.51M8.7 22H16.3C17.4201 22 17.9802 22 18.408 21.782C18.7843 21.5903 19.0903 21.2843 19.282 20.908C19.5 20.4802 19.5 19.9201 19.5 18.8V5.2C19.5 4.07989 19.5 3.51984 19.282 3.09202C19.0903 2.71569 18.7843 2.40973 18.408 2.21799C17.9802 2 17.4201 2 16.3 2H8.7C7.5799 2 7.01984 2 6.59202 2.21799C6.21569 2.40973 5.90973 2.71569 5.71799 3.09202C5.5 3.51984 5.5 4.0799 5.5 5.2V18.8C5.5 19.9201 5.5 20.4802 5.71799 20.908C5.90973 21.2843 6.21569 21.5903 6.59202 21.782C7.01984 22 7.57989 22 8.7 22ZM13 17.5C13 17.7761 12.7761 18 12.5 18C12.2239 18 12 17.7761 12 17.5C12 17.2239 12.2239 17 12.5 17C12.7761 17 13 17.2239 13 17.5Z" stroke="#9197B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <select
                                value={district}
                                onChange={(e) => setdistrict(e.target.value)}
                               
                                disabled={!province}
                                required
                                >
                                <option value="">Select District</option>
                                {districtOptions.map((dist) => (
                                    <option key={dist} value={dist}>
                                    {dist}
                                    </option>
                                ))}
                                </select>
                                </div>

                           

                            <div className="col-md-6 py-0">
                                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.4997 13.43C14.2228 13.43 15.6197 12.0331 15.6197 10.31C15.6197 8.58687 14.2228 7.19 12.4997 7.19C10.7766 7.19 9.37971 8.58687 9.37971 10.31C9.37971 12.0331 10.7766 13.43 12.4997 13.43Z" stroke="#9197B3" stroke-width="1.5" />
                                    <path d="M4.11971 8.49C6.08971 -0.169998 18.9197 -0.159997 20.8797 8.5C22.0297 13.58 18.8697 17.88 16.0997 20.54C14.0897 22.48 10.9097 22.48 8.88971 20.54C6.12971 17.88 2.96971 13.57 4.11971 8.49Z" stroke="#9197B3" stroke-width="1.5" />
                                </svg>

                                <input
                                    type="text" className='m-0'
                                    placeholder='Agency Address'
                                    required
                                    value={address}
                                    onChange={(e) => setaddress(e.target.value)}
                                />
                            </div>
                            <div className="col-md-6 py-0">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                </svg>

                                <input
                                    type="text" className='m-0'
                                    placeholder='Agency Enrollment Number'
                                    required
                                    value={reg_no}
                                    onChange={(e) => setreg_no(e.target.value)}
                                />
                            </div>

                            <div className="col-md-6 py-0">
                                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.5 11V8.2C22.5 7.0799 22.5 6.51984 22.282 6.09202C22.0903 5.71569 21.7843 5.40973 21.408 5.21799C20.9802 5 20.4201 5 19.3 5H5.7C4.5799 5 4.01984 5 3.59202 5.21799C3.21569 5.40973 2.90973 5.71569 2.71799 6.09202C2.5 6.51984 2.5 7.0799 2.5 8.2V11.8C2.5 12.9201 2.5 13.4802 2.71799 13.908C2.90973 14.2843 3.21569 14.5903 3.59202 14.782C4.01984 15 4.5799 15 5.7 15H11.5M12.5 10H12.505M17.5 10H17.505M7.5 10H7.505M19.75 17V15.25C19.75 14.2835 18.9665 13.5 18 13.5C17.0335 13.5 16.25 14.2835 16.25 15.25V17M12.75 10C12.75 10.1381 12.6381 10.25 12.5 10.25C12.3619 10.25 12.25 10.1381 12.25 10C12.25 9.86193 12.3619 9.75 12.5 9.75C12.6381 9.75 12.75 9.86193 12.75 10ZM17.75 10C17.75 10.1381 17.6381 10.25 17.5 10.25C17.3619 10.25 17.25 10.1381 17.25 10C17.25 9.86193 17.3619 9.75 17.5 9.75C17.6381 9.75 17.75 9.86193 17.75 10ZM7.75 10C7.75 10.1381 7.63807 10.25 7.5 10.25C7.36193 10.25 7.25 10.1381 7.25 10C7.25 9.86193 7.36193 9.75 7.5 9.75C7.63807 9.75 7.75 9.86193 7.75 10ZM16.1 21H19.9C20.4601 21 20.7401 21 20.954 20.891C21.1422 20.7951 21.2951 20.6422 21.391 20.454C21.5 20.2401 21.5 19.9601 21.5 19.4V18.6C21.5 18.0399 21.5 17.7599 21.391 17.546C21.2951 17.3578 21.1422 17.2049 20.954 17.109C20.7401 17 20.4601 17 19.9 17H16.1C15.5399 17 15.2599 17 15.046 17.109C14.8578 17.2049 14.7049 17.3578 14.609 17.546C14.5 17.7599 14.5 18.0399 14.5 18.6V19.4C14.5 19.9601 14.5 20.2401 14.609 20.454C14.7049 20.6422 14.8578 20.7951 15.046 20.891C15.2599 21 15.5399 21 16.1 21Z" stroke="#9197B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <input
                                    type="password"
                                    placeholder='Password' className='m-0'
                                    required
                                    value={password}
                                    onChange={(e) => setpassword(e.target.value)}
                                />
                            </div>
                        </div>
                        <button type="submit" className="btn submit_btn w-100 mt-4" disabled={isLoading}>Register</button>
                        <p className='mt-3 text-center'>Already an account? <Link to='/'>Login Now!</Link></p>

                    </form>
                </div>
            </div>

        </div>
    );
}
